import { clsx } from 'clsx'
import { type FC, useState } from 'react'

import { AD_BANNER_TOP_BANNER } from '../../adServerConst'

import styles from './AdServerBannerLegalText.module.css'

type AdServerBannerLegalTextProps = {
  id: string
  label: string
  text: string
}

export const AdServerBannerLegalText: FC<AdServerBannerLegalTextProps> = ({
  id,
  label,
  text,
}) => {
  const [visible, setVisible] = useState(false)
  const isTopBanner = id === AD_BANNER_TOP_BANNER
  const showTextUnderneath = isTopBanner && visible

  return (
    <div
      className={clsx(
        styles['ad-server-banner-legal-text'],
        isTopBanner && styles['ad-server-banner-legal-text_top-banner'],
        showTextUnderneath && styles['ad-server-banner-legal-text_underneath'],
      )}
      data-legal-text-underneath={showTextUnderneath ? '' : undefined}
    >
      <button
        className="rounded-tr-s bg-light-brand-high px-3 py-0.5 underline"
        onClick={(): void => {
          setVisible(!visible)
        }}
        type="button"
      >
        {label}
      </button>
      <button
        className="overflow-y-auto bg-light-brand-medium px-1 py-0.5 text-left"
        hidden={!visible}
        onClick={(): void => {
          setVisible(!visible)
        }}
        type="button"
      >
        <span
          // eslint-disable-next-line react/no-danger -- data are sanitized within retail media api - https://github.com/RedTecLab/retail-media-adserver-api/blob/main/src/services/kevel/KevelDecisionService.ts#L876
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </button>
    </div>
  )
}
